import React from 'react';
import { normalizeSrc } from '../ContentFeature/helpers';
import { StyledListIconImage } from './styles';

interface IconListImageProps {
  src: string;
  width?: string;
  height?: string;
  alt?: string;
  'data-content'?: string;
}

export const IconListImage: React.FC<IconListImageProps> = ({
  src,
  width,
  height,
  alt,
  'data-content': dataContent,
  ...props
}) => {
  return (
    <StyledListIconImage
      src={normalizeSrc(src)}
      width={width}
      height={height}
      {...props}
    />
  );
};
